import { getFormattedStringDate } from "utils/helper";
import InboxAppsButton from "../InboxAppsButton/InboxAppsButton";
import ExternalEmailsCheckbox from "./ExternalEmailsCheckbox/ExternalEmailsCheckbox";
import { availableInboxApps } from "../../../../enum";
import IntegrationsAccessControl from "components/dashboard/AgentInbox/AgentInboxSettings/AppIntegrations/IntegrationsAccessControl/IntegrationsAccessControl";
import "./ConnectedApp.scss";

const { GMAIL } = availableInboxApps;

const ConnectedApp = ({
    connectedApp,
    actionType,
    appSource,
    handleNewConnection,
    user,
    handleSuccess,
    handleError,
    handleActionModal,
}) => {
    const { screenName, connectionDate, appUserId, forExternalEmails } =
        connectedApp || {};

    const actions = (
        <>
            {appSource === GMAIL && (
                <div className='external__emails__checkbox__container col-3'>
                    <IntegrationsAccessControl>
                        <ExternalEmailsCheckbox
                            forExternalEmails={forExternalEmails}
                            appUserId={appUserId}
                            handleSuccess={handleSuccess}
                        />
                    </IntegrationsAccessControl>
                </div>
            )}
            <div className='col-1'>
                <IntegrationsAccessControl>
                    <InboxAppsButton
                        actionType={actionType}
                        appSource={appSource}
                        handleNewConnection={handleNewConnection}
                        user={user}
                        appUserId={appUserId}
                        handleSuccess={handleSuccess}
                        handleError={handleError}
                        handleActionModal={handleActionModal}
                    />
                </IntegrationsAccessControl>
            </div>
        </>
    );

    return (
        <>
            <div className='appUser__row'>
                <div className='row'>
                    <div className='col-3'>
                        <p>{screenName}</p>
                    </div>
                    <div className='col-3'>
                        <p>{getFormattedStringDate(connectionDate)}</p>
                    </div>
                    {appSource === GMAIL ? (
                        actions
                    ) : (
                        <div className='col-4'>
                            <InboxAppsButton
                                actionType={actionType}
                                appSource={appSource}
                                handleNewConnection={handleNewConnection}
                                user={user}
                                appUserId={appUserId}
                                handleSuccess={handleSuccess}
                                handleError={handleError}
                                handleActionModal={handleActionModal}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ConnectedApp;
